import { APP_NAME } from '../utils/branding';
import React from 'react';
import { FaFacebook, FaTwitter, FaWhatsapp, FaEnvelope, FaLink, FaTimes } from 'react-icons/fa';
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton, EmailShareButton } from 'react-share';
import { sharePhoto } from '../services/api';
import { toast } from 'react-toastify';

function ShareMenu({ photoId, photoUrl, onClose }) {
  const shareUrl = `${window.location.origin}/photo/${photoId}`;
  const title = `Découvrez cette superbe photo sur ${APP_NAME} !`;

  const handleShare = async (platform) => {
    try {
      await sharePhoto(photoId, platform);
    } catch (error) {
      console.error('Error tracking share:', error);
    }
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      await sharePhoto(photoId, 'link');
      toast.success('Lien copié dans le presse-papiers !');
      onClose();
    } catch (error) {
      toast.error('Impossible de copier le lien');
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'transparent',
          zIndex: 999
        }}
      />

      {/* Menu */}
      <div style={{
        position: 'absolute',
        bottom: '60px',
        right: 0,
        background: '#FFFFFF',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
        padding: '1rem',
        minWidth: '200px',
        zIndex: 1000
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1rem',
          paddingBottom: '0.5rem',
          borderBottom: '1px solid var(--border)'
        }}>
          <h4 style={{ margin: 0, color: '#1F2937' }}>Partager la photo</h4>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '1.2rem',
              color: '#64748B'
            }}
          >
            <FaTimes />
          </button>
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem'
        }}>
          <FacebookShareButton
            url={shareUrl}
            quote={title}
            onClick={() => handleShare('facebook')}
            style={{
              width: '100%',
              background: 'none',
              border: 'none',
              padding: '0.8rem',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              cursor: 'pointer',
              borderRadius: '8px',
              transition: 'background 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'var(--surface-2)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
          >
            <FaFacebook style={{ fontSize: '1.5rem', color: '#60A5FA' }} />
            <span style={{ color: '#1F2937', fontWeight: '500' }}>Facebook</span>
          </FacebookShareButton>

          <TwitterShareButton
            url={shareUrl}
            title={title}
            onClick={() => handleShare('twitter')}
            style={{
              width: '100%',
              background: 'none',
              border: 'none',
              padding: '0.8rem',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              cursor: 'pointer',
              borderRadius: '8px',
              transition: 'background 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'var(--surface-2)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
          >
            <FaTwitter style={{ fontSize: '1.5rem', color: '#60A5FA' }} />
            <span style={{ color: '#1F2937', fontWeight: '500' }}>Twitter</span>
          </TwitterShareButton>

          <WhatsappShareButton
            url={shareUrl}
            title={title}
            onClick={() => handleShare('whatsapp')}
            style={{
              width: '100%',
              background: 'none',
              border: 'none',
              padding: '0.8rem',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              cursor: 'pointer',
              borderRadius: '8px',
              transition: 'background 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'var(--surface-2)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
          >
            <FaWhatsapp style={{ fontSize: '1.5rem', color: '#4ADE80' }} />
            <span style={{ color: '#1F2937', fontWeight: '500' }}>WhatsApp</span>
          </WhatsappShareButton>

          <EmailShareButton
            url={shareUrl}
            subject={title}
            body={`Découvrez cette photo : ${shareUrl}`}
            onClick={() => handleShare('email')}
            style={{
              width: '100%',
              background: 'none',
              border: 'none',
              padding: '0.8rem',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              cursor: 'pointer',
              borderRadius: '8px',
              transition: 'background 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'var(--surface-2)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
          >
            <FaEnvelope style={{ fontSize: '1.5rem', color: '#F87171' }} />
            <span style={{ color: '#1F2937', fontWeight: '500' }}>E-mail</span>
          </EmailShareButton>

          <button
            onClick={copyToClipboard}
            style={{
              width: '100%',
              background: 'none',
              border: 'none',
              padding: '0.8rem',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              cursor: 'pointer',
              borderRadius: '8px',
              transition: 'background 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'var(--surface-2)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
          >
            <FaLink style={{ fontSize: '1.5rem', color: '#4F46E5' }} />
            <span style={{ color: '#1F2937', fontWeight: '500' }}>Copier le lien</span>
          </button>
        </div>
      </div>
    </>
  );
}

export default ShareMenu;
